export enum SelectedTab {
  Home = 'Home',
  Inbox = 'Inbox',
  Assets = 'Assets',
  Ships = 'Ships',
  Inspections = 'Inspections',
  FleetAnalysis = 'Fleet Analysis',
  Publisher = 'Publisher',
  HealthPlans = 'Health Plans',
  Budgeting = 'Budgeting',
  InspectionScheduling = 'Inspection Scheduling',
  AvailabilityPlanning = 'Availability Planning',
  Overview = 'Overview',
  Cases = 'Cases',
  Exploration = 'Exploration',
  Explorer = 'Explorer',
  Prism = 'Prism',
  PartsThread = 'Parts Thread',
  JobsOverview = 'Jobs Overview',
  Walkdowns = 'Walkdowns',
  Reporting = 'Reporting',
  InventoryManagement = 'Inventory Management',
  Maximo = 'Maximo',
  SystemLens = 'System Lens',
  PointCloud = 'Point Cloud',
  ProcessFlowDiagrams = 'Process Flow Diagrams',
  ValueStories = 'Value Stories',
  ImportWizard = 'Import Wizard',
  ProcessData = 'Process Data',
  Walkthrough = 'Walkthrough',
  AnomalyDetection = 'Anomaly Detection',
  Documents = 'Documents',
  Libra = 'Libra',
}
